/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Description/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Description({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CreateProcedureReceivables/NewTask/Content/Description",
  onChange
  
}) {
let eventActionDataNewTaskDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.new_task.description',
})
let eventActionDataNewTaskDescriptionChangeData = fromData.useDataChange({ viewPath,
context: 'event_action',
path: 'data.new_task.description',
})
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 data="event_action.data.new_task.description"
 value={eventActionDataNewTaskDescriptionValueData}
 onChange={eventActionDataNewTaskDescriptionChangeData}
 placeholder="Description of the task. Keep it concise, and clear."
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Description"
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}